function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { uniq } from 'lodash/array';
var GalleryTabs = /*#__PURE__*/ function() {
    "use strict";
    function GalleryTabs() {
        _class_call_check(this, GalleryTabs);
        _define_property(this, "$slider", document.querySelector('[data-gallery-tabs-slider]'));
        _define_property(this, "$arrow", this.$slider.querySelector('.gallery-tabs__arrow'));
        _define_property(this, "$tabsHolder", document.querySelector('.gallery-tabs'));
        _define_property(this, "$tabsHeading", document.querySelector('.gallery-tabs__heading'));
        _define_property(this, "$tabs", document.querySelectorAll('[data-gallery-tabs-item]'));
    }
    _create_class(GalleryTabs, [
        {
            key: "handleChangeTab",
            value: function handleChangeTab() {
                var _this = this;
                var timeout = setTimeout(function() {
                    var _tabsActive_, _tabsActive_1;
                    var slidesVisible = uniq(window.sliderTabs.slides.filter(function(item) {
                        return item.classList.contains('swiper-slide-visible');
                    }).map(function(item) {
                        return item.dataset.galleryTabsSlide;
                    }));
                    _this.$tabs.forEach(function($item) {
                        $item.classList.toggle('gallery-tabs__item_active', slidesVisible.includes($item.dataset.galleryTabsItem));
                    });
                    var tabsActive = document.querySelectorAll('.gallery-tabs__item_active');
                    var tabActiveFirstSizes = (_tabsActive_ = tabsActive[0]) === null || _tabsActive_ === void 0 ? void 0 : _tabsActive_.getBoundingClientRect();
                    var tabActiveLastSizes = (_tabsActive_1 = tabsActive[tabsActive.length - 1]) === null || _tabsActive_1 === void 0 ? void 0 : _tabsActive_1.getBoundingClientRect();
                    var tabsHolderSizes = _this.$tabsHolder.getBoundingClientRect();
                    if (tabActiveFirstSizes.x < tabsHolderSizes.x) {
                        _this.$tabsHeading.scrollLeft -= tabsHolderSizes.x - tabActiveFirstSizes.x;
                    }
                    var tabLength = tabActiveLastSizes.x + tabActiveLastSizes.width;
                    var tabsLength = tabsHolderSizes.x + tabsHolderSizes.width;
                    if (tabLength > tabsLength) {
                        _this.$tabsHeading.scrollLeft += tabLength - tabsLength;
                    }
                    clearTimeout(timeout);
                }, 1000);
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                if (this.$slider) {
                    this.$slider.addEventListener('mouseenter', function() {
                        _this.$slider.classList.add('gallery-tabs__slider_arrow');
                    });
                    this.$slider.addEventListener('mousemove', function(event) {
                        var $el = event.target;
                        _this.$arrow.style.top = "".concat(event.offsetY, "px");
                        _this.$arrow.style.left = "".concat(event.pageX, "px");
                        _this.$slider.classList.toggle('gallery-tabs__slider_left', $el.classList.contains('swiper-button-prev'));
                        _this.$slider.classList.toggle('gallery-tabs__slider_right', $el.classList.contains('swiper-button-next'));
                    });
                    this.$slider.addEventListener('mouseleave', function() {
                        _this.$slider.classList.remove('gallery-tabs__slider_arrow');
                    });
                }
                window.sliderTabs.on('slideChange', function() {
                    _this.handleChangeTab();
                });
                this.$tabs.forEach(function($item) {
                    $item.addEventListener('click', function() {
                        var $slideTab = window.sliderTabs.slides.filter(function(slide) {
                            return slide.dataset.galleryTabsSlide === $item.dataset.galleryTabsItem;
                        })[0];
                        window.sliderTabs.slideTo(window.sliderTabs.slides.findIndex(function(item) {
                            return item === $slideTab;
                        }), 1000);
                    });
                });
            //
            }
        }
    ]);
    return GalleryTabs;
}();
export default GalleryTabs;
